// WBWB Components
import Vue from 'vue';
import WbwbDashboardAlert from '@/components/wbwb/wbwb-dashboard-alert.vue';
import WbwbEventList from '@/components/wbwb/wbwb-event-list.vue';
import WbwbEventSearch from '@/components/wbwb/wbwb-event-search.vue';

Vue.component('wbwb-dashboard-alert', WbwbDashboardAlert);
Vue.component('wbwb-event-list', WbwbEventList);
Vue.component('wbwb-event-search', WbwbEventSearch);



// WEBPACK FOOTER //
// ./src/app/wbwb.js